import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74831922"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tips" }
const _hoisted_2 = { style: {"font-size":"15px","font-weight":"bold"} }
const _hoisted_3 = { style: {"font-size":"12px","margin-top":"8px"} }
const _hoisted_4 = { style: {"font-size":"12px","margin-top":"4px"} }
const _hoisted_5 = { style: {"font-size":"12px","margin-top":"4px"} }
const _hoisted_6 = { style: {"font-size":"12px","margin-top":"4px"} }
const _hoisted_7 = { class: "annbg" }
const _hoisted_8 = { class: "ann" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "inputWarn" }
const _hoisted_11 = { class: "bottom" }
const _hoisted_12 = { class: "cancel" }
const _hoisted_13 = { class: "confirm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$t('me.zxzh'),
      "left-arrow": "",
      fixed: "",
      "safe-area-inset-top": "",
      onClickLeft: $setup.onClickLeft
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('me.delaccount')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('me.delaccontent1')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('me.delaccontent2')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('me.delaccontent3')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('me.delaccontent4')), 1 /* TEXT */),
      _createElementVNode("div", null, [
        _createVNode(_component_van_button, {
          class: "button",
          onClick: $setup.delAccount
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('me.zxzh')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(_component_van_overlay, {
      show: $setup.showAnn,
      "lock-scroll": false,
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "anndialog",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('me.delaccontent6')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('me.delaccontent5')), 1 /* TEXT */),
              _createVNode(_component_van_field, {
                modelValue: $setup.userId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userId) = $event)),
                type: "text",
                placeholder: _ctx.$t('me.delaccontent7'),
                class: "input"
              }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", {
                class: "concalbutton",
                onClick: $setup.onConfirm
              }, _toDisplayString(_ctx.$t('me.ok')), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", {
                class: "confirmbutton",
                onClick: $setup.onCancel
              }, _toDisplayString(_ctx.$t('tips.cancel')), 1 /* TEXT */)
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ]))
}